'use strict';

const fAccordion = () => {
    const aAccordions = document.querySelectorAll(".js-accordion");

    const fInitAccordion = (oAccordion) => {
        const aTriggers = oAccordion.querySelectorAll(".js-accordion-open");
        const bOpenOne = (oAccordion.getAttribute("data-accordion-openOne") === 'true');

        for (let b = 0; b < aTriggers.length; b += 1) {
            const oParent = aTriggers[b].parentNode;
            const oCollapse = oParent.querySelector(".js-accordion-collapse");
            const oFormButton = oParent.querySelector('.form .button');

            if (!oCollapse) return;

            oCollapse.style.height = "0px";
            oCollapse.style.position = "relative";
            oCollapse.style.opacity = 1;
            oCollapse.style.visibility = "visible";

            aTriggers[b].addEventListener("click", () => {
                if (oParent.getAttribute("data-accordion-active")) {
                    oCollapse.style.height = "0px";
                    oCollapse.style.overflow = "hidden";
                    oParent.removeAttribute("data-accordion-active");
                } else {
                    let oCollapseHeight = (oCollapse) ? oCollapse.querySelector(".js-accordion-collapse-body").offsetHeight : null;
                    if (bOpenOne) {
                        let oCurrent = oAccordion.querySelector('[data-accordion-active="true"]');
                        if (oCurrent) {
                            let oCurrentCollapse = oCurrent.querySelector(".js-accordion-collapse");

                            oCurrentCollapse.style.height = "0px";
                            oCurrent.style.overflow = "hidden";
                            oCurrent.removeAttribute("data-accordion-active");
                        }
                    }
                    oCollapse.style.height = `${oCollapseHeight}px`;
                    oParent.setAttribute("data-accordion-active", true);

                    setTimeout(() => {
                        oCollapse.style.overflow = "visible";
                    }, 250)
                }
            });

            // Reset height if form is validated
            if (oFormButton) {
                oFormButton.addEventListener('click', () => {
                    if (oParent.getAttribute('data-accordion-active')) {
                        setTimeout(function () {
                            oCollapse.style.height = 'auto';
                            oCollapseHeight = (oCollapse) ? oCollapse.offsetHeight : null;
                            oCollapse.style.height = `${oCollapseHeight}px`;
                        }, 100);
                    }
                });
            }
        }
    };

    for (let a = 0; a < aAccordions.length; a += 1) {
        fInitAccordion(aAccordions[a]);
    }
}